export const DEFAULT_COUNT_OF_VISIBLE_FILTERS = 5;
